import styled from 'styled-components'
import { fluidSize } from '../../utils/style'

export const FilterWrapper = styled.div<{ isVisible: boolean }>`
	display: flex;
	align-items: center;
	gap: ${fluidSize(12)};
	margin-bottom: ${fluidSize(16)};
	padding: 0 ${fluidSize(30)};
	visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
`

export const FilterLabel = styled.span`
	font-size: ${fluidSize(14)};
	font-weight: 500;
	color: white;
`

export const FilterButton = styled.button`
	display: flex;
	align-items: center;
	gap: ${fluidSize(8)};
	padding: ${fluidSize(8)} 0;
	background-color: unset;
	border: unset;
	cursor: pointer;
	font-size: ${fluidSize(14)};
	color: white;
	transition: all 0.2s ease;
	font-weight: bold;
	font-family: 'Outfit', sans-serif;

	&:active {
		transform: scale(0.98);
	}
`

export const FilterIconWrapper = styled.div`
	border-radius: ${fluidSize(10)};
	display: flex;
	justify-content: center;
	align-items: center;
	width: ${fluidSize(28)};
	height: ${fluidSize(28)};
	border: ${fluidSize(1)} solid #356cf8;
`

export const ChevronIcon = styled.div`
	background-image: url("data:image/svg+xml,%3Csvg width='10' height='16' viewBox='0 0 10 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath id='4273_vector' d='M9.45355 7.99548C9.45355 7.76777 9.36247 7.54014 9.18939 7.38525L1.96716 0.336045C1.81233 0.181232 1.61196 0.0901489 1.38428 0.0901489C0.910686 0.0901489 0.546386 0.445394 0.546386 0.918926C0.546386 1.14664 0.637463 1.35609 0.783183 1.51098L7.91436 8.48729L7.91436 7.51278L0.783184 14.4891C0.637464 14.6349 0.546387 14.8443 0.546387 15.0811C0.546387 15.5547 0.910687 15.9099 1.38428 15.9099C1.61196 15.9099 1.81233 15.8188 1.97627 15.664L9.18939 8.6148C9.36247 8.44175 9.45355 8.23228 9.45355 7.99548Z' fill='white'/%3E%3C/svg%3E%0A");
	width: 50%;
	height: 50%;
	background-repeat: no-repeat;
	background-size: contain;
	transform: translateY(25%) rotate(90deg);
`
